<template>
  <div id="layout" class="default" :class="{ pinned: sidebarPinned, collapsed: sidebarCollapsed }">
    <div class="wrapper">
      <sidebar entity="Layout/Sidebar" component="Sidebar" :class="{ pinned: sidebarPinned, collapsed: sidebarCollapsed }" />
      <div class="main" :class="{ pinned: sidebarPinned, collapsed: sidebarCollapsed }">
        <header>
          <top-header />
        </header>
        <section>
          <main class="content py-3 py-md-4 px-0">
            <router-view :key="$route.meta?.dontReuse ? $route.path : null" />
          </main>
        </section>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import TopHeader from '@/components/Layout/Header/Header'
// import Sidebar from '@/components/ProductDistributor'

export default {
  name: 'LayoutDefault',
  components: {
    TopHeader
    // Sidebar
  },
  // computed: {
  //   productPath() {
  //     Vue.component('sidebar', () => import(`@/components/Layout/Sidebar/${this.productPath}Sidebar`))
  //     return this.ecosystem.product.charAt(0).toUpperCase() + this.ecosystem.product.substr(1).toLowerCase() + '/'
  //   }
  // },
  watch: {
    productPath(val) {
      if (val) {
        Vue.component('sidebar', () => import(`@/components/Layout/Sidebar/${this.productPath}Sidebar`))
      }
    }
  }
}
</script>

<style lang="scss">
#layout {
  &.default {
    position: fixed;
    top: 0;
    left: 0;
    height: 100vh;
    width: 100%;
    .wrapper {
      width: 100%;
      display: flex;
      flex-direction: row;
      height: 100%;
      .main {
        width: 100%;
        display: flex;
        flex-direction: column;
        height: 100vh;
        overflow: hidden;
        padding-left: 160px;
        transition: padding-left .3s ease;
        &.pinned {
          padding-left: 40px;
        }
        &.collapsed {
          padding-left: 0;
        }
        > header {
          flex: 0 0 40px;
          border-bottom: 1px solid #eee;
          box-shadow: 0 0 10px rgba(0, 0, 0, .1) !important;
          background-color: #fff;
          position: relative;
          z-index: 10001;
        }
        section {
          flex: 1;
          overflow: hidden;
          .content {
            height: 100%;
            overflow: auto;
          }
        }
        footer {
          flex: 0 0 20px;
          background-color: #C14F4F;
        }
      }
    }
  }
}
</style>
